import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Survey.css';

const Excel = () => {
  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="excel-container">
      <button onClick={goBack}>Go Back</button>
      <iframe src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTf7Xc-aZL9c-sRtLunCwKiFQzeRpwLH7oRpGphkYQVR8c6W3-IIPoJhzEm31ptSR3YRaw8ZTkspM2c/pubhtml?widget=true&amp;headers=false" width="1500" height="1030"></iframe>

    </div>
  );
};

export default Excel;
